import React from "react";
import { TimeFormatter } from "../../../../utils/TimeFormatter";

import "@styles/c-scenarioTime.scss";

interface Props {
  ellapsedTime: number;
  totalTime: number;
  isMultiElementScenario?: boolean;
  className?: string;
}

export const ScenarioTimeComponent: React.FC<Props> = ({ ellapsedTime, totalTime, isMultiElementScenario, className }) => {
  const isReady = isMultiElementScenario !== undefined;

  if (!isReady) {
    return <div className={`${className || ""} c-scenarioTime`} />;
  }
  return (
    <div className={`${className || ""} c-scenarioTime`}>
      <div className="c-scenarioTime__ellapsedTime">{TimeFormatter.format(ellapsedTime)}</div>
      {!isMultiElementScenario && <div className="c-scenarioTime__totalTime">{TimeFormatter.format(totalTime)}</div>}
    </div>
  );
};
